'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _map2 = require('lodash/map');

var _map3 = _interopRequireDefault(_map2);

var _isString2 = require('lodash/isString');

var _isString3 = _interopRequireDefault(_isString2);

var _isNumber2 = require('lodash/isNumber');

var _isNumber3 = _interopRequireDefault(_isNumber2);

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function SelectOption(_ref) {
  var value = _ref.value,
      name = _ref.name,
      active = _ref.active;

  return _react2.default.createElement(
    'option',
    { className: (0, _classnames2.default)({ active: active }), value: value },
    name
  );
}
SelectOption.propTypes = {
  active: _propTypes2.default.bool,
  name: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.string.isRequired
};
SelectOption.defaultProps = {
  active: false,
  value: ''
};
function getOptValue(arg, value) {
  if ((0, _isString3.default)(arg.value)) return arg.value;
  if ((0, _isString3.default)(value)) return value;
  if ((0, _isNumber3.default)(arg)) return arg.toString();
  return arg;
}
function getOptName(arg) {
  if ((0, _isString3.default)(arg.name)) return arg.name;
  if ((0, _isNumber3.default)(arg)) return arg.toString();
  return arg;
}
function opts(arg, id, value) {
  var val = getOptValue(arg, id);
  return {
    active: value === val,
    key: id,
    value: val,
    name: getOptName(arg)
  };
}

function Select(_ref2) {
  var firstOptionName = _ref2.firstOptionName,
      options = _ref2.options,
      value = _ref2.value,
      required = _ref2.required,
      props = _objectWithoutProperties(_ref2, ['firstOptionName', 'options', 'value', 'required']);

  if ((0, _isEmpty3.default)(options)) return _react2.default.createElement(
    'div',
    null,
    'NO OPTIONS'
  );
  return _react2.default.createElement(
    'select',
    _extends({}, props, { value: value }),
    !required && _react2.default.createElement(SelectOption, { name: firstOptionName }),
    (0, _map3.default)(options, function (opt, id) {
      return _react2.default.createElement(SelectOption, opts(opt, id, value));
    })
  );
}

Select.propTypes = {
  firstOptionName: _propTypes2.default.string,
  onBlur: _propTypes2.default.func,
  onChange: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.objectOf(_propTypes2.default.string)]).isRequired,
  required: _propTypes2.default.bool,
  value: _propTypes2.default.string
};
Select.defaultProps = {
  firstOptionName: '- All -',
  onBlur: undefined,
  required: false,
  value: ''
};
exports.default = Select;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/cape-mixer/lib/SelectEl.js
// module id = 307
// module chunks = 0